import { X, Calendar, Bell } from "lucide-react";
import { Link } from "react-router-dom";

export default function ComingSoonModal({
  isOpen,
  onClose,
  featureName = "This feature",
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-in fade-in duration-200"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="relative w-full max-w-md bg-white dark:bg-[#1E1E1E] rounded-3xl shadow-2xl animate-in zoom-in-95 fade-in duration-200">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-[#666666] hover:text-black dark:text-[#A0A0A0] dark:hover:text-white transition-colors rounded-full hover:bg-[#F5F5F5] dark:hover:bg-[#2A2A2A]"
          aria-label="Close modal"
        >
          <X size={20} />
        </button>

        {/* Content */}
        <div className="p-8 text-center">
          {/* Icon */}
          <div className="mx-auto w-20 h-20 mb-6 bg-gradient-to-br from-[#62397f] to-[#7C3AED] rounded-full flex items-center justify-center shadow-lg">
            <Calendar size={40} className="text-white" />
          </div>

          {/* Title */}
          <h2 className="text-2xl md:text-3xl font-bold text-black dark:text-white mb-3">
            Coming Soon!
          </h2>

          {/* Description */}
          <p className="text-[#666666] dark:text-[#A0A0A0] text-base mb-6 leading-relaxed">
            <span className="font-semibold text-black dark:text-white">
              {featureName}
            </span>{" "}
            is currently under development. We're working hard to bring you this
            amazing feature soon!
          </p>

          {/* Notification Card */}
          <div className="mb-6 p-5 bg-[#F5F3FF] dark:bg-[#2A2440] rounded-2xl border border-[#E9D5FF] dark:border-[#4C3A5C]">
            <div className="flex items-center justify-center gap-2 mb-2">
              <Bell size={18} className="text-[#62397f]" />
              <span className="text-sm font-semibold text-black dark:text-white">
                Want to be notified?
              </span>
            </div>
            <p className="text-xs text-[#666666] dark:text-[#A0A0A0]">
              Contact us to get updates when this feature launches
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-6 py-3 bg-[#62397f] hover:bg-[#7C3AED] text-white font-semibold rounded-xl transition-all duration-200 shadow-[0_4px_12px_rgba(139,92,246,0.3)]"
            >
              Got it, thanks!
            </button>
            <Link
              to="/contact"
              className="flex-1 px-6 py-3 bg-white dark:bg-[#2A2A2A] border-2 border-[#62397f] text-[#62397f] dark:text-[#A78BFA] font-semibold rounded-xl hover:bg-[#F5F3FF] dark:hover:bg-[#342A50] transition-all duration-200"
            >
              Contact Us
            </Link>
          </div>
        </div>

        {/* Decorative element */}
        <div className="absolute -top-2 -right-2 w-24 h-24 bg-[#62397f]/10 rounded-full blur-2xl -z-10" />
        <div className="absolute -bottom-2 -left-2 w-24 h-24 bg-[#7C3AED]/10 rounded-full blur-2xl -z-10" />
      </div>
    </div>
  );
}
